export default class PostCalculator {
  $counter;
  limit;
  $target;

  constructor($target, $counter) {
    this.$counter = $counter;
    this.$target = $target;

    this.limit = 2000;

    this.calculate = this.calculate.bind(this);
  }

  calculate(update_display = true) {
    var remaining = this.limit - this.$target.val().length;

    if (update_display) {
      this.update_display(remaining);
    }

    return remaining;
  }

  isWithinLimit() {
    return this.calculate(false) >= 0;
  }

  resetCount() {
    this.update_display(this.limit);
  }

  update_display(count) {
    this.$counter.text(count);
    if (count < 0) {
      this.$counter.addClass('has-warning');
      this.$counter.prev().addClass('has-warning');
    } else {
      this.$counter.removeClass('has-warning');
      this.$counter.prev().removeClass('has-warning');
    }
  }
}
